import { ElNotification } from 'element-plus'

interface NotificationConfig {
  title?: string
  message?: string
  type?: 'success' | 'warning' | 'info' | 'error' | ''
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
  duration?: number
}

const defaultNotificationConfig: NotificationConfig = {
  type: 'success',
  position: 'top-right',
  duration: 2000
}

export const notification = (message: string, config?: NotificationConfig) => {
  let dft = { ...defaultNotificationConfig, ...config }
  dft.type = 'info'
  dft.message = message
  ElNotification(dft)
}

export const warning = (message: string, config?: NotificationConfig) => {
  let dft = { ...defaultNotificationConfig, ...config }
  dft.type = 'warning'
  dft.message = message
  ElNotification(dft)
}

export const success = (message: string, config?: NotificationConfig) => {
  let dft = { ...defaultNotificationConfig, ...config }
  dft.message = message
  ElNotification(dft)
}

export const error = (message: string, config?: NotificationConfig) => {
  let dft = { ...defaultNotificationConfig, ...config }
  dft.type = 'error'
  dft.message = message
  ElNotification(dft)
}
